var Preload = function(game){};


Preload.prototype = {
  

	preload: function(){ 
		//this.load.setCORS('anonymous');
        
      	if (screen.width < 1281 && screen.width > 900){
          this.game.load.image('tile', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/full_wave_small.png?625');
          this.game.load.image('cloud1', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/cloud_small.png?625');
          this.game.load.image('bottle', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/bottle_small.png?622');
          this.game.load.image('shark', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/shark_fin_small.png?625');
          this.game.load.image('buoy', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/small_buoy.png?625');
          this.game.load.image('xmark', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/x_sprite.png?700');


          this.game.load.spritesheet('player', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/mega_player_small.png?625', 240, 240, 3, 0);
          this.game.load.spritesheet('waves', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/full_wave_anim.png?708', 1000, 192, 3, 0);
        }
      	else {
          this.game.load.image('tile', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/full_wave.png?625');
          this.game.load.image('cloud1', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/cloud.png?625');
          this.game.load.image('bottle', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/bottle_large.png?622');
          this.game.load.image('shark', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/shark_fin.png?625');
          this.game.load.image('buoy', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/large_buoy.png?625');
          this.game.load.image('xmark', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/x_sprite.png?700');


          this.game.load.spritesheet('player', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/mega_player_small.png?625', 240, 240, 3, 0);
          this.game.load.spritesheet('waves', 'https://cdn.shopify.com/s/files/1/0084/5188/3108/t/7/assets/full_wave_anim.png?708', 1000, 192, 3, 0);
        }
	},

	create: function(){
		this.game.state.start("Main");
	}
}